(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('HomeTest', HomeTest);

    HomeTest.$inject = ['$resource'];

    function HomeTest ($resource) {
        var resourceUrl =  'api/advertising-test';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data, headersGetter, status) {
                    if (data && status != 502) {
                        data = angular.fromJson(data);
                    } else {
                        data = {data: '', status: status};
                    }
                    return data;
                }
            }
        });
    }
})();
